import { component } from 'picoapp';
import Cookies from 'js-cookie';
import '@/lib/jquery-global.js';
import 'slick-carousel';

export default component((node, ctx) => {
    
})